/* eslint-disable */
/**
 * menu.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2018, Codrops
 * http://www.codrops.com
 */
import anime from './anime.min';

class Box {
  constructor(el, pos) {
    this.DOM = {el: el};
    this.DOM.bg = this.DOM.el.querySelector('.grim__item-bg');
    this.DOM.inner = this.DOM.el.querySelector('.grim__item-content > .grim__item-inner');
    this.DOM.link = this.DOM.el.querySelector('a.grim__link');
    this.pos = pos;
  }
  open() {
    return new Promise((resolve, reject) => {
      this.DOM.bg.style.transformOrigin = this.pos % 2 === 0 ? '50% 100%' : '0% 50%';

      anime.remove(this.DOM.bg);
      anime({
        targets: this.DOM.bg,
        duration: this.DOM.bg.dataset.duration || 30+this.pos*20, // increment as more boxes get revealed..
        easing: this.DOM.bg.dataset.easing || 'easeInOutQuad',
        opacity: {
          value: 1,
          duration: 1
        },
        scaleY: this.pos % 2 === 0 ? [0,1] : 1,
        scaleX: Math.abs(this.pos % 2) == 1 ? [0,1] : 1,
        complete: resolve
      });

      if ( this.DOM.inner ) {
        anime.remove(this.DOM.inner);
        anime({
          targets: this.DOM.inner,
          duration: 1300,
          delay: 550,
          easing: 'easeOutExpo',
          opacity: {
            value: 1,
            duration: 1
          },
          translateY: ['100%','0%']
        });
      }
    });
  }
}

export default class Menu {
  constructor(el) {
    this.DOM = {el: el};
    this.DOM.grim = el;
    this.DOM.items = Array.from(this.DOM.el.querySelectorAll('.grim__item'));
    this.itemsTotal = this.DOM.items.length;
    this.boxes = [];
    this.DOM.items.forEach((item, pos) => {
      this.boxes.push(new Box(item, pos));
    });
  }
  open() {
    this.toggle('open');
  }
  toggle(action) {
    if ( this.isAnimating ) return;
    this.isAnimating = true;
    this.openBoxes();
  }
  openBoxes(pos = 0) {
    this.toggleBoxes('open', pos);
  }
  toggleBoxes(action, pos) {
    if ( pos >= this.itemsTotal ) {
      this.isAnimating = false;
      return;
    };
    this.DOM.grim.classList[action === 'open' ? 'add' : 'remove']('grim--open');
    const box = this.boxes[pos];
    box[action === 'open' ? 'open' : 'close']().then(() => this[action === 'open' ? 'openBoxes' : 'closeBoxes'](pos+1));
  }
}



// WEBPACK FOOTER //
// ./scripts/components/menu.js